import {setupButtonClick} from "../utils/ui";
import BaseScene from "./baseScene";
import LocalStorage from "../utils/localStorage";

function revisedRandId() {
    return Math.floor((Math.random() * 1000));
}

export default class NameInput extends BaseScene {

    constructor () {
        super('NameInput');
    }

    init() {}

    preload() {
        this.load.image('btn_ok', 'src/assets/img/arrow.png');
        this.load.image('track', 'src/assets/img/strip.png');
        this.load.image('background', 'src/assets/img/star_fire.jpg');
    }

    create() {
        super.create();
        this.cameras.main.fadeIn(500, 0, 0, 0);

        const frontImage = this.add.image(this.scale.width / 2 , this.scale.height / 2,"background");

        frontImage.setDepth(-1);

        this.boardImg = this.add.image(this.scale.width / 2 , this.scale.height /2,"board");
        this.boardImg.setScale(0.6);

        const title = this.add.image(this.scale.width / 2 + 10, this.scale.height / 6,"title");
        title.setScale(1.15);
        title.setOrigin(0.5);

        this.menuText = this.add.text(this.scale.width / 2, this.scale.height /3, "Name",
            { fontFamily: 'Splurge', fontSize: 60, align: "center", fill: "#141" }
        )
        this.menuText.setOrigin(0.5)

        this.btnNameOk = this.add.image(this.game.config.width / 2, this.game.config.height/ 2 + 200, "btn_ok");
        this.btnNameOk.setScale(0.25);

        let name = `Fox#${revisedRandId()}`;

        this.strip = this.add.image(this.game.config.width / 2, this.game.config.height / 2 + 35, "track");

        this.strip.setScale(0.44, 0.05);

        this.createTextInput(500, this.game.config.width / 2, this.game.config.height / 2, "60px", name, "#222");

        setupButtonClick(this.btnNameOk, () => {
            this.cameras.main.fadeOut(500, 0, 0, 0);
            this.cameras.main.once(Phaser.Cameras.Scene2D.Events.FADE_OUT_COMPLETE, (cam, effect) => {
                LocalStorage.setPlayerName(this.textInput.text);
                this.scene.start("Menu");
            })
        })

        this.helpBackground = this.add.image(130 , this.scale.height - 50,"name_background");
        this.helpBackground.setRotation(Math.PI / 2)
        this.helpBackground.setScale(0.5, 0.5);

        this.descriptionText = this.add.text(
            30,
            this.game.config.height - 260,
            "Minimum 3 Characters\n\nMaximum 10 Characters\n\nNo Special Characters",
            {
                font: "28px Splurge",
                fill: "#eee",
                align: "center",
                wordWrap: {
                    width: 200
                }
            }
        );
    }


    createTextInput(width, x, y, fontSize, text, color, maxLength = 10){
        this.textInput = this.add.rexCanvasInput(
            {
                width,
                x,
                y,

                background: {
                    color: null,
                    color2: null,
                    horizontalGradient: true,

                    stroke: null,
                    strokeThickness: 2,

                    cornerRadius: 0,
                    cornerIteration: null,

                    // Style when focus
                    'focus.color': "white",
                },

                wrap: {
                    lineHeight: undefined,
                    useDefaultLineHeight: true,
                    maxLines: 1,
                    wrapWidth: undefined,
                    letterSpacing: 0,
                    hAlign: 0,
                    vAlign: 'center',  // For single line text input
                    charWrap: true,    // For single line text input
                },

                style: {
                    fontSize,
                    color,
                    fontFamily: "Splurge",
                    backgroundBottomY: 5,
                    backgroundHeight: fontSize,
                    align: "center",

                    // Solution A
                    'cursor.color': '#444',
                    'cursor.backgroundColor': 'white',
                },

                text,
                inputType: "text",
                textArea: false,
                selectAll: true,
                maxLength: maxLength,
                minLength: 3,
                onUpdate: () => {
                    const visible = /^[a-zA-Z0-9#]{3,10}$/.test(this.textInput.text)
                    this.btnNameOk.visible = visible;
                }
            }
        )
    }
}